import http from 'utils/http';

export const fetchOrganizationPaymentMethods = () => http
  .get('v1/organizations/{{organizationId}}/payment-methods/')
  .then((res) => res.data);

export const createStripeIntent = () => http
  .get('v1/organizations/{{organizationId}}/payment-methods/setup-intent/')
  .then(({ data }) => data);
